var map = {
	"./pt/1/image1.png": [
		53742,
		3742
	],
	"./pt/10/image1.png": [
		9143,
		9143
	],
	"./pt/2/image1.png": [
		63578,
		3578
	],
	"./pt/3/image1.png": [
		23371,
		3371
	],
	"./pt/4/image1.png": [
		2793,
		2793
	],
	"./pt/5/image1.png": [
		86005,
		6005
	],
	"./pt/6/image1.png": [
		14230,
		4230
	],
	"./pt/7/image1.png": [
		12007,
		2007
	],
	"./pt/8/image1.png": [
		33075,
		3075
	],
	"./pt/9/image1.png": [
		18539,
		8539
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 59452;
module.exports = webpackAsyncContext;